import React, { useEffect } from 'react';
import get from 'lodash/get';
import { useDispatch, useSelector } from 'react-redux';
import { Page } from 'modules/ui';
import { getAccount, useTealiumView } from 'modules/accounts';
import { ProducerTalentDetails } from '../components';
import { getTalent, loadTalent } from '../redux';
import TalentPreviewHeader from './TalentPreviewHeader';
import { useNavigate, useParams } from 'react-router-dom';
import { ScrollingProvider } from 'modules/core';
import {
  getAgentAssignments,
  getAgentsLoading,
  loadAgentAssignments,
} from 'modules/agents';

export default function TalentPreviewPage() {
  const params = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const talentId = get(params, 'talentId');
  const account = useSelector(getAccount);
  const agentAssignments = useSelector(getAgentAssignments);
  const agentsLoading = useSelector(getAgentsLoading);
  const loadedTalent = useSelector(getTalent);

  useTealiumView('Talent Profile Page');

  // TODO: the two useEffects below are convoluted and I hate them, but this is finally working for all use cases
  // and there's no infinite rendering, so it'll do for now. I would love to extract this out to a generic
  // privilges wrapper for all the pages at some point.

  // Trigger data fetching for fresh page loads. 'account' is preloaded from the accounts/redux.js file, but
  // 'agentAssignments' is not.
  useEffect(() => {
    if (account.agent && !agentAssignments) {
      dispatch(loadAgentAssignments());
    }
  }, [account, agentAssignments, dispatch]);

  // Determine if this account is allowed to view this profile.
  useEffect(() => {
    // Early return if agent data is still loading, or if talent has been loaded already.
    if (
      !account ||
      (loadedTalent && loadedTalent.id === talentId) ||
      account.agent & agentsLoading
    ) {
      return;
    }

    // if this an agent and the assignments are finished loading, see if the talent is in the assignments
    if (account.agent && agentAssignments) {
      if (
        agentAssignments.length !== 0 &&
        agentAssignments.some(
          talentAssignment =>
            String(talentAssignment.talentId) === String(talentId),
        )
      ) {
        dispatch(loadTalent(talentId));
      } else {
        // talent profile does not belong to the agent; redirect to homepage
        navigate('/');
      }
    } else if (!account.agent && !agentsLoading) {
      dispatch(loadTalent(talentId));
    }
  }, [
    dispatch,
    navigate,
    talentId,
    agentAssignments,
    agentsLoading,
    loadedTalent,
    account,
  ]);

  return (
    <Page HeaderComponent={<TalentPreviewHeader talentId={talentId} />}>
      <ScrollingProvider />
      <ProducerTalentDetails talentId={talentId} />
    </Page>
  );
}
